import { Component, OnInit } from '@angular/core';
import { FinancialCalculator } from '@classes/financial';
import { endOfLocalDay, localDateInputValue, startOfLocalDay } from '@classes/dates';
import { PaymentService } from '@services/payment.service';

@Component({
  selector: 'app-daily-ledger',
  templateUrl: './daily-ledger.component.html',
  styleUrls: ['./daily-ledger.component.css'],
})
export class DailyLedgerComponent implements OnInit {
  rows: any[] = [];
  loading = false;
  loaded = false;
  error = '';
  startDate = '';
  endDate = '';
  displayedColumns = ['invoice', 'type', 'name', 'tax', 'new', 'discount', 'paid', 'method'];

  constructor(private paymentService: PaymentService) {
    const today = localDateInputValue();
    this.startDate = today;
    this.endDate = today;
  }

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.error = '';
    const start = startOfLocalDay(this.startDate);
    const end = endOfLocalDay(this.endDate);
    this.paymentService.dailyLedger(start, end).subscribe({
      next: (rows) => {
        this.rows = rows || [];
        this.loaded = true;
        this.loading = false;
      },
      error: (err) => {
        this.rows = [];
        this.loaded = true;
        this.loading = false;
        this.error = err?.error?.message || 'Could not load ledger';
      },
    });
  }

  money(value: any): string {
    return FinancialCalculator.formatMoney(value);
  }
}
